// LoginClass.js
import React, { Component } from "react";
import { jwtDecode } from "jwt-decode";
import { toast, ToastContainer } from "react-toastify";
//import ApiLoader from "../../components/Loader/ApiLoader";
import microsoft_logo from '../../../../images/Microsoft_logo.svg.png';
import { addAnalytics } from '../../../Common/analytics';
import API from '../../../Common/api';
import LoadingOverlay from 'react-loading-overlay';
import DarkBackground from '../../../Common/backgroundLoader';
import { Card, CardBody, Col, Button, ButtonToolbar, Modal } from "reactstrap";

//import "react-toastify/dist/ReactToastify.css";
import '../login.css';

const url = window.location.hostname;
var portData = window.location.port;

class LogInMicrosoft extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoading: false,
      loaderMessage: null,
      location_list: [],
      loading_overlay : false,
      loading_text : 'signin...',
      failed_modal : false,
      failed_message : ''
      //showLocationUI: true

    };
  }

  componentDidMount() {
    this.handleRedirectLogin();
  }

//   createCookie = (cookieName, cookieValue, daysToExpire = 1) => {
//   const date = new Date();
//   date.setTime(date.getTime() + daysToExpire * 24 * 60 * 60 * 1000);
//   document.cookie =
//     `${cookieName}=${cookieValue}; expires=${date.toUTCString()}; path=/; SameSite=Lax`;
// };
createCookie = (cookieName, cookieValue, daysToExpire = 1) => {
  const date = new Date();
  date.setTime(date.getTime() + daysToExpire * 24 * 60 * 60 * 1000);

  let cookieStr = `${cookieName}=${cookieValue}; expires=${date.toUTCString()}; path=/; SameSite=Lax`;

  // Add Secure flag only on HTTPS
  if (window.location.protocol === "https:") {
    cookieStr += "; Secure";
  }

  document.cookie = cookieStr;
};

accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }
  deleteCookie = (name) => {
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  };
Failedtoggle= () =>{
    this.setState((prevState) => ({ failed_modal: !prevState.failed_modal }));
  }
handleRedirectLogin = async () => {
  const { instance } = this.props;

  try {
    const response = await instance.handleRedirectPromise();
    const loggedOut = sessionStorage.getItem("loggedOut");
    if (loggedOut === "true" ) {
        setTimeout(() => {
        sessionStorage.removeItem("loggedOut");
        }, 5000);
        return
      }
    
    if (response && response.idToken) {
      await this.handleLoginResponse(response.idToken);
    } else {
      const accounts = instance.getAllAccounts();
      const token = this.accessCookie("token"); // check your session
      if (accounts.length > 0 && !token) {
        // Only silent login if no session token
        const silentResponse = await instance.acquireTokenSilent({
          scopes: ["openid", "profile", "email"],
          account: accounts[0],
        });
        await this.handleLoginResponse(silentResponse.idToken);
      }
      // If token exists, do nothing → prevents automatic login
    }
  } catch (err) {
    alert("Microsoft login failed. Contact tech support.");
  }
};


  handleLoginResponse = async (idToken) => {
    try {
      const decoded = jwtDecode(idToken);

      sessionStorage.setItem("MicrosoftTokenId", idToken);
      sessionStorage.setItem("MicrosoftMailId", decoded.email);
      sessionStorage.setItem("MicrosoftName", decoded.name);
      this.setState({
        loading_overlay : true
      })
      await this.onLogin({ ...decoded, idToken });
    } catch (err) {
      this.setState({ showLoading: false });
      toast.error(
        (err.response && err.response.data && err.response.data.message) ||
        "Something went wrong. Try again later"
      );
    }
  };

  onLogin = async (idToken)=> {
    if (this.state.username === "") {
    
      this.setState({
        showUserNameMsg: true,
      });
    } else if (this.state.password === "") {
      this.setState({
        showPassMsg: true,
      });
    } else {
      addAnalytics('Microsoft Login', 'Password Login')
      
      const payload = {
          id_token : idToken.idToken
      };

      API.post('/auth/auth/microsoft_login/', { param: payload })
        .then((response) => {
          if (response.data.success == false) {
            this.deleteCookie("userLocations");
            this.deleteCookie("token");
            this.deleteCookie("userName")
              this.setState({
                failed_message : response.data.reason,
                failed_modal : true
              });
          } 
          else if(response.data.success == true) {
              this.setState({loading_overlay : false})
              this.deleteCookie("selectedLocation");
              this.createCookie("token", response.data.token);
              this.createCookie("userLocations", response.data.user_locations);
              this.createCookie("userName", response.data.user.name);
              this.createCookie("tezz_warehouse", response.data.tezz_warehouse)
              window.location.href =   window.location.protocol+"//" + url + ":" + portData + "/location_selection" ;
          }
          
          else {
              this.deleteCookie("selectedLocation");
              
            // }
          }
        }).catch(function (error) {
          // this.deleteCookie("userLocations", []);
          this.deleteCookie("token");
          this.deleteCookie("userName")
          this.setState({
                failed_message : error.response.data.reason,
                failed_modal : true,
                loading_overlay : false
              });
        }.bind(this));
    }
  }

  handleMicrosoftLogin = () => {
    this.props.instance.loginRedirect({
      scopes: ["openid", "profile", "email"],
    });
  };

  render() {
    const { showLoading, loaderMessage } = this.state;

    if (!this.props.isLoggedIn) {
      return (
        <div className="loginContainer">
          {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>
           
            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loading_text}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
          <div className="Login">
            <button
              type="button"
              className="microsoft-btn btn-clean"
              onClick={this.handleMicrosoftLogin}
              disabled={showLoading}
            >
              <img style={{width: '10%'}} src={microsoft_logo} alt="Microsoft logo"  />
              Sign in with Microsoft
            </button>
          </div>
          <Modal isOpen={this.state.failed_modal} backdrop="static" toggle={this.Failedtoggle}>
                    <div className="modal__header">
                      <button
                        className="lnr lnr-cross modal__close-btn"
                        type="button"
                        style={{ right: 15 }}
                        // onClick={this.Failedtoggle}
                      />
                    </div>
                    <div
                      className="modal__body"
                      style={{ paddingTop: 55, paddingBottom: 20 }}
                    >
                      <span
                        className="lnr lnr-cross-circle modal__title-icon"
                        style={{ color: "red" }}
                      />
                      <h4>{this.state.failed_message} </h4>
                    </div>
                    <ButtonToolbar className="modal__footer">
                      <Button
                        style={{ backgroundColor: "#24d6a3", color: "#fff" }}
                        className="modal_ok"
                        onClick={this.Failedtoggle}
                      >
                        Ok
                      </Button>
                    </ButtonToolbar>
                  </Modal>
        </div>
      );
    } else {
      this.props.navigate("/");
      return null;
    }
  }
}

export default LogInMicrosoft;
